import React, { Component } from "react";
import {
  Row,
  Col,
  Table,
  Drawer,
  Checkbox,
  Button,
  Typography,
  Popconfirm,
} from "antd";
import NumberFormat from "react-number-format";
import { withRouter } from "react-router-dom";
import "./Criteria.css";
import CriteriaAdd from "./CriteriaAdd";
import PlusIcon from "../../../svg/svgicon/PlusIcon";
import ButtonLinkIcon from "../../../Components/MyComponent/ButtonLinkIcon";
import { API } from "../../../API/API";
import { DeleteOutlined } from "@ant-design/icons";
import UserContext from "../../UserContext/UserContext";

const { Text } = Typography;
class CriteriaList extends Component {
  static contextType = UserContext;

  state = {
    invitationid: this.props.invitationid,
    isEdit: this.props.isEdit,
    data: [],
    showNewInputForm: false,
    selectedCriteriaId: 0,
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getCriteriaList?invitationid=" + this.state.invitationid).then(
      (response) => {
        if (response.status === 200) {
          this.setState((prevState) => ({
            data: response.data.retData,
            dkey: prevState.dkey + 1,
          }));
        }
      }
    );
  };
  showNewInputFormHandler = (show, criteriaid) => {
    this.setState({
      showNewInputForm: show,
      selectedCriteriaId: criteriaid,
    });
    if (show === false) {
      this.getData();
    }
  };
  handleDelete = (id) => {
    API.get("deleteCriteria?id=" + id).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        const dataSource = [...this.state.data];
        this.setState({
          data: dataSource.filter((item) => item.criteriaid !== id),
        });
      }
    });
  };
  render() {
    const columns = [
      {
        title: "Шалгуурын төрөл",
        dataIndex: "criteriatypename",
        key: "criteriatypename",
        width: "25%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              className="link"
              type="link"
              onClick={() =>
                this.showNewInputFormHandler(true, record.criteriaid)
              }
            >
              {record.criteriatypename}
            </Button>
          );
        },
      },
      {
        title: "Нэмэлт тайлбар",
        dataIndex: "criterianame",
        key: "criterianame",
        width: "25%",
        align: "left",
      },
      {
        title: "Хувийн жин",
        dataIndex: "weight",
        key: "weight",
        width: "5%",
        align: "left",
      },

      {
        title: "Урилга дээр харуулах эсэх",
        dataIndex: "visible",
        key: "visible",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <Checkbox
              disabled
              value={record.visible === 1 ? true : false}
              defaultChecked={record.visible === 1 ? true : false}
            />
          );
        },
      },
      {
        title: " ",
        dataIndex: "operation",
        width: "3%",
        render: (_, record) =>
        this.context.permission.isAdmin === "1" ?
         this.props.isEdit ? 
          true ? (
            <Popconfirm
              title="Уcтгахдаа итгэлтэй байна уу?"
              onConfirm={() => this.handleDelete(record.criteriaid)}
            >
              <Button
                type="link"
                icon={<DeleteOutlined style={{ color: "red" }} />}
              />
            </Popconfirm>
          ) : null
          : null
          : null,
      },
    ];
    return (
      <div className="Container" key={this.state.dkey}>
        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">3. Шалгуур үзүүлэлт</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
              {this.context.permission.isAdmin === "1" ?
                this.props.isEdit ? 
                <ButtonLinkIcon
                  onClick={() => this.showNewInputFormHandler(true, 0)}
                  icon={<PlusIcon />}
                  name="Шалгуур үзүүлэлт нэмэх"
                /> : null 
                : null}
              </Col>
            </Row>
          </Col>
        </Row>

        <div id="criteria">
          <Table
            dataSource={this.state.data}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "7%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={false}
            rowKey="criteriaid"
            scroll={{ y: 340 }}
            summary={(pageData) => {
              let totalWeight = 0;

              pageData.forEach(({ weight, visible }) => {
                totalWeight += Number(weight);
              });
              return (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell>Нийт</Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <Text style={{ fontWeight: 600 }}>
                        <NumberFormat
                          displayType="text"
                          value={totalWeight}
                        ></NumberFormat>
                      </Text>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </>
              );
            }}
          />
        </div>
        {this.context.permission.isAdmin === "1" ?         
        <Drawer
          title="Шалгуур үзүүлэлт нэмэх"
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0)}
          destroyOnClose={true}
          style
        >
          <CriteriaAdd
            criteriaid={this.state.selectedCriteriaId}
            invitationid={this.state.invitationid}
            showForm={this.showNewInputFormHandler}
            isEdit={this.state.isEdit}
          ></CriteriaAdd>
        </Drawer> : null }
      </div>
    );
  }
}

export default withRouter(CriteriaList);
